import STCProtectionsAndPayment from './STCProtectionsAndPayment';

export default STCProtectionsAndPayment;
